var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44745 9.50141C1.25745 9.50141 1.06745 9.43141 0.917451 9.28141C0.627451 8.99141 0.627451 8.51141 0.917451 8.22141L4.11745 5.02141C4.27745 4.86141 4.48745 4.78141 4.71745 4.80141C4.93745 4.82141 5.13745 4.94141 5.26745 5.13141L6.35745 6.77141L9.90745 3.22141C10.1975 2.93141 10.6775 2.93141 10.9675 3.22141C11.2575 3.51141 11.2575 3.99141 10.9675 4.28141L6.76745 8.48141C6.60745 8.64141 6.39745 8.72141 6.16745 8.70141C5.94745 8.68141 5.74745 8.56141 5.61745 8.37141L4.52745 6.73141L1.97745 9.28141C1.82745 9.43141 1.63745 9.50141 1.44745 9.50141Z",
    fill: "#0DA14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.447 6.5C10.037 6.5 9.69702 6.16 9.69702 5.75V4.5H8.44702C8.03702 4.5 7.69702 4.16 7.69702 3.75C7.69702 3.34 8.03702 3 8.44702 3H10.447C10.857 3 11.197 3.34 11.197 3.75V5.75C11.197 6.16 10.857 6.5 10.447 6.5Z",
    fill: "#0DA14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.9babab918d8cfdab14b0d1e38dc86649.svg";
export { ForwardRef as ReactComponent };